module.exports = __webpack_public_path__ + "static/media/red-flag.59e44990.svg";